module.exports = __webpack_public_path__ + "static/img/anj_new_company_img.cad3db70.jpg";